const SOCIO_QUALIFICACAO = Object.freeze({
    '00': { id: '00', descricao: 'Não informada' },
    '05': { id: '05', descricao: 'Administrador' },
    '08': { id: '08', descricao: 'Conselheiro de Administração' },
    '09': { id: '09', descricao: 'Curador' },
    10: { id: '10', descricao: 'Diretor' },
    11: { id: '11', descricao: 'Interventor' },
    12: { id: '12', descricao: 'Inventariante' },
    13: { id: '13', descricao: 'Liquidante' },
    14: { id: '14', descricao: 'Mãe' },
    15: { id: '15', descricao: 'Pai' },
    16: { id: '16', descricao: 'Presidente' },
    17: { id: '17', descricao: 'Procurador' },
    18: { id: '18', descricao: 'Secretário' },
    19: { id: '19', descricao: 'Síndico (Condomínio)' },
    20: { id: '20', descricao: 'Sociedade Consorciada' },
    21: { id: '21', descricao: 'Sociedade Filiada' },
    22: { id: '22', descricao: 'Sócio' },
    23: { id: '23', descricao: 'Sócio Capitalista' },
    24: { id: '24', descricao: 'Sócio Comanditado' },
    25: { id: '25', descricao: 'Sócio Comanditário' },
    26: { id: '26', descricao: 'Sócio de Indústria' },
    28: { id: '28', descricao: 'Sócio-Gerente' },
    29: { id: '29', descricao: 'Sócio Incapaz ou Relat.Incapaz (exceto menor)' },
    30: { id: '30', descricao: 'Sócio Menor (Assistido/Representado)' },
    31: { id: '31', descricao: 'Sócio Ostensivo' },
    32: { id: '32', descricao: 'Tabelião' },
    33: { id: '33', descricao: 'Tesoureiro' },
    34: { id: '34', descricao: 'Titular de Empresa Individual Imobiliária' },
    35: { id: '35', descricao: 'Tutor' },
    37: { id: '37', descricao: 'Sócio Pessoa Jurídica Domiciliado no Exterior' },
    38: { id: '38', descricao: 'Sócio Pessoa Física Residente no Exterior' },
    39: { id: '39', descricao: 'Diplomata' },
    40: { id: '40', descricao: 'Cônsul' },
    41: { id: '41', descricao: 'Representante de Organização Internacional' },
    42: { id: '42', descricao: 'Oficial de Registro' },
    43: { id: '43', descricao: 'Responsável' },
    46: { id: '46', descricao: 'Ministro de Estado das Relações Exteriores' },
    47: { id: '47', descricao: 'Sócio Pessoa Física Residente no Brasil' },
    48: { id: '48', descricao: 'Sócio Pessoa Jurídica Domiciliado no Brasil' },
    49: { id: '49', descricao: 'Sócio-Administrador' },
    50: { id: '50', descricao: 'Empresário' },
    51: { id: '51', descricao: 'Candidato a cargo Político Eletivo' },
    52: { id: '52', descricao: 'Sócio com Capital' },
    53: { id: '53', descricao: 'Sócio sem Capital' },
    54: { id: '54', descricao: 'Fundador' },
    55: { id: '55', descricao: 'Sócio Comanditado Residente no Exterior' },
    56: { id: '56', descricao: 'Sócio Comanditário Pessoa Física Residente no Exterior' },
    57: { id: '57', descricao: 'Sócio Comanditário Pessoa Jurídica Domiciliado no Exterior' },
    58: { id: '58', descricao: 'Sócio Comanditário Incapaz' },
    59: { id: '59', descricao: 'Produtor Rural' },
    60: { id: '60', descricao: 'Cônsul Honorário' },
    61: { id: '61', descricao: 'Responsável indígena' },
    62: { id: '62', descricao: 'Representante da Instituição Extraterritorial' },
    63: { id: '63', descricao: 'Cotas em Tesouraria' },
    64: { id: '64', descricao: 'Administrador Judicial' },
    65: { id: '65', descricao: 'Titular Pessoa Física Residente ou Domiciliado no Brasil' },
    66: { id: '66', descricao: 'Titular Pessoa Física Residente ou Domiciliado no Exterior' },
    67: { id: '67', descricao: 'Titular Pessoa Física Incapaz ou Relativamente Incapaz (exceto menor)' },
    68: { id: '68', descricao: 'Titular Pessoa Física Menor (Assistido/Representado)' },
    69: { id: '69', descricao: 'Beneficiário Final' },
    70: { id: '70', descricao: 'Administrador Residente ou Domiciliado no Exterior' },
    71: { id: '71', descricao: 'Conselheiro de Administração Residente ou Domiciliado no Exterior' },
    72: { id: '72', descricao: 'Diretor Residente ou Domiciliado no Exterior' },
    73: { id: '73', descricao: 'Presidente Residente ou Domiciliado no Exterior' },
    74: { id: '74', descricao: 'Sócio-Administrador Residente ou Domiciliado no Exterior' },
    75: { id: '75', descricao: 'Fundador Residente ou Domiciliado no Exterior' },
    78: { id: '78', descricao: 'Titular Pessoa Jurídica Domiciliada no Brasil' },
    79: { id: '79', descricao: 'Titular Pessoa Jurídica Domiciliada no Exterior' }
});

module.exports = SOCIO_QUALIFICACAO;
